export default {
  root: {
    background: '#fff',
    boxShadow: '0px 1px 8px rgba(0,0,0,0.1)',
    padding: [12, 24, 16],
    transition: 'all .2s',
    marginTop: 16
  }
};
